export const dateFormat = "dd/MM/yyyy"
export const dateFormatPlaceholder = "dd/mm/yyyy"